import { Injectable } from '@angular/core';
import moment from 'moment';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root',
})
export class CachingService {
  constructor(private localStorageService: LocalStorageService) {}

  cacheDataModel(model: any, modelKey: string, overwrite = false) {
    let cachedModel = this.localStorageService.retrieve(modelKey);

    const ageInHours = moment(new Date()).diff(
      moment(cachedModel?.date),
      'hours',
      true,
    );

    // older cache entries > 2 should not be used anymore, use newer api model
    if (ageInHours > 2) {
      this.localStorageService.clear(modelKey);
      cachedModel = null;
    }

    if (!cachedModel || overwrite) {
      this.localStorageService.store(modelKey, {
        model,
        date: new Date(),
      });
      return model;
    }

    return cachedModel.model;
  }
}
